import { Row } from './types';
import { sumColumns } from '../common';
import { Link } from 'react-router-dom';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';
import { ClientTitle } from 'components';

export const columns: ControlledTableColumns<Row> = [
  {
    content: 'Agency',
    key: 'enterprise_slug',
    width: 80,
  },
  flexColumn({
    content: 'Client',
    key: 'client_internal_name',
    sortable: true,
    render: ({ client_internal_name, payer_internal_name }) => (
      <ClientTitle
        client={{
          internal_name: client_internal_name,
        }}
        payer={{
          internal_name: payer_internal_name,
        }}
      />
    ),
  }),
  flexColumn({
    content: 'Brand',
    key: 'brand_title',
    sortable: true,
  }),
  flexColumn({
    content: 'Campaign',
    key: 'campaign_title',
    required: true,
    sortable: true,
    render: ({ enterprise_slug, campaign_id, campaign_title }) => (
      <Link to={`/${enterprise_slug}/planning/campaigns/${campaign_id}/planning`}>{campaign_title}</Link>
    ),
  }),
  ...sumColumns,
];
